
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.13498',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.13498",
  "apollo-dlb": "static-3.98",
  "breeze-builder-lib": "static-1.1123",
  "client-types": "static-1.510",
  "data-fetching-client": "static-1.10108",
  "foundations-components": "static-1.8738",
  "foundations-components-legacy": "static-1.1763",
  "foundations-theming": "static-1.4957",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.93",
  "head-dlb": "static-1.5007",
  "hs-test-utils": "static-1.8506",
  "hub-http-shared-msw-handlers": "static-1.10889",
  "hubspot-dlb": "static-2.1911",
  "hubspot-url-utils": "static-1.4383",
  "HubStyleTokens": "static-2.11957",
  "I18n": "static-7.1706",
  "jasmine-runner": "static-1.6920",
  "marketplace-discovery-studio-lib": "static-1.894",
  "marketplace-storefront-base": "static-1.13561",
  "quartz": "static-1.7646",
  "react-dlb": "static-1.93",
  "react-rhumb": "static-1.17204",
  "reactive-variable-buffer-atom": "static-1.3321",
  "reporting-testing-lib": "static-1.11257",
  "reselect": "static-3.16",
  "settings-ui-lib": "static-1.12997",
  "SharedI18nStrings": "static-1.187",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.7838",
  "ui-addon-i18n": "static-1.11616",
  "ui-addon-react-router-dom": "static-1.9997",
  "unified-auth": "static-1.1236",
  "unified-auth-core-lib": "static-1.1518",
  "usage-tracker": "static-1.7792",
  "usage-tracker-core": "static-1.7642",
  "customer-data-property-utils": "static-1.8518",
  "hub-http": "static-1.6677",
  "integrations-lib": "static-1.17416",
  "marketplace-ui-common": "static-1.21036",
  "marketplace-ui-install": "static-1.1022",
  "property-management-iframe": "static-1.14438",
  "quartz-config": "static-1.1424",
  "quartz-core": "static-1.6865",
  "quartz-routing": "static-1.1076",
  "quick-fetch": "static-1.4229",
  "react": "static-7.202",
  "rpc-client-utils": "static-1.5139",
  "ts-schema": "static-1.4391",
  "ui-universal-auth": "static-1.9722",
  "UIComponents": "static-3.8903",
  "apollo-stack-hubspot": "static-3.94",
  "enviro": "static-4.455",
  "hs-promise-rejection-tracking": "static-1.5587",
  "PortalIdParser": "static-2.404",
  "raven": "static-3.5925",
  "raven-hubspot": "static-1.6232",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.88",
  "metrics-js": "static-1.9990",
  "react-redux": "static-7.80",
  "redux": "static-4.81",
  "styled-components": "static-2.100",
  "moment": "static-3.75",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3923",
  "quartz-webpack": "static-1.3870",
  "bend-plugin-quartz-routing": "static-1.724",
  "ai-components-ui-library": "static-1.10006",
  "codemirror": "static-5.106",
  "foundations-assets": "static-1.5354",
  "pulse": "static-1.1115",
  "react-codemirror": "static-1.11109",
  "ui-extensions-preview-lib": "static-1.944",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.5007",
  "floating-ui": "static-1.67",
  "foundations-theming-specialty": "static-1.2673",
  "framer-motion": "static-1.83",
  "hs-story-utils": "static-1.9892",
  "react-aria": "static-1.76",
  "react-create-root-preference": "static-1.101",
  "react-select-plus": "static-1.117",
  "react-utils": "static-2.5654",
  "react-virtualized": "static-2.111",
  "StyleGuideUI": "static-3.518",
  "tanstack-table": "static-1.65",
  "trellis-assets": "static-1.3068",
  "ui-fonts": "static-1.1219",
  "ui-images": "static-2.1276",
  "bend-plugin-foundations-theming": "static-1.3440",
  "foundations-theming-base": "static-1.3942",
  "stylex": "static-1.46",
  "HeadJS": "static-2.820",
  "hs-test-utils-bend-plugin": "static-1.3617",
  "msw": "static-1.102",
  "msw-config": "static-1.27",
  "testing-library": "static-1.163",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.234",
  "moment-timezone": "static-5.95",
  "jasmine": "static-4.4778",
  "ui-addon-video-player": "static-1.9093",
  "ai-rendering-library": "static-1.11386",
  "chirp-fetch": "static-1.2372",
  "connections-embed-lib": "static-1.1734",
  "copilot-toolkit": "static-1.12132",
  "feedback-loader": "static-1.30050",
  "laboratory-lib": "static-3.7617",
  "marketplace-embed": "static-1.23189",
  "marketplace-ui-details": "static-1.10931",
  "marketplace-ui-reviews": "static-1.20991",
  "marketplace-ui-tracking": "static-1.15206",
  "sanitize-text": "static-1.8627",
  "usage-tracker-multi": "static-1.6206",
  "usage-tracker-session-replay": "static-1.5478",
  "wootric-nps": "static-1.7295",
  "beacon-keepalive-queue": "static-1.169",
  "quartz-head": "static-1.1311",
  "web-vitals": "static-1.19",
  "apollo-link-hub-http": "static-2.5056",
  "immer": "static-1.105",
  "immerable": "static-1.4611",
  "highcharts": "static-8.115",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2828",
  "reporting-data": "static-1.69324",
  "cssUtils": "static-1.1093",
  "flux-actions": "static-1.380",
  "react-colorpicker": "static-2.10678",
  "react-dnd-compat": "static-1.5080",
  "redux-observable": "static-1.79",
  "ReduxMessenger": "static-2.10838",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7782",
  "icons": "static-2.702",
  "marketplace-ui-apps-core": "static-1.19568",
  "storybook-react": "static-1.44",
  "trellis-story-utils": "static-1.4968",
  "foundations-components-test-utils": "static-1.6221",
  "quartz-i18n": "static-1.1321",
  "react-input-autosize": "static-2.17",
  "adobe-sign-auth-lib": "static-1.750",
  "ads-unified-auth-lib": "static-1.1936",
  "ai-mcp-auth-lib": "static-1.10",
  "custom-vendor-connection-lib": "static-1.286",
  "google-sheets-integration-lib": "static-1.1319",
  "microsoft-drive-auth-lib": "static-1.479",
  "slack-ui-library": "static-1.10869",
  "surveymonkey-integration-lib": "static-1.852",
  "fsm": "static-1.4227",
  "customer-data-objects": "static-1.8168",
  "property-translator": "static-1.5848",
  "hs-locale-management": "static-1.398",
  "frontend-preferences-client": "static-1.8390",
  "hs-promise-utils": "static-1.6061",
  "hubspot-apollo-client": "static-1.5349",
  "integrations-error-boundary-lib": "static-1.14831",
  "integrations-tracking-lib": "static-1.6086",
  "native-integrations-shared-strings": "static-1.8231",
  "sanitize": "static-1.4942",
  "superstore": "static-1.5227",
  "ui-shepherd-react": "static-3.10746",
  "ai-settings-ui-library": "static-1.8573",
  "hub-http-janus": "static-1.905",
  "hubspotter-http": "static-1.4973",
  "immutable-less": "static-1.5122",
  "marketplace-ui-client-types": "static-1.18443",
  "nav-meta": "static-1.30791",
  "react-window": "static-1.13",
  "ui-addon-upgrades": "static-9.18545",
  "ui-product-approvals-common": "static-1.1564",
  "ai-studio-lib": "static-1.12749",
  "hubspot-prosemirror": "static-1.19265",
  "integrations-reconnect-lib": "static-1.707",
  "ui-addon-iframeable": "static-1.9543",
  "ui-addon-integrations-directory-panel": "static-2.8422",
  "ui-product-approvals": "static-1.29669",
  "ui-tool-access": "static-1.10627",
  "inbound-db-properties-service-client": "static-1.4150",
  "property-management-common": "static-1.6726",
  "opentelemetry-fe-types": "static-1.261",
  "dispatcher": "static-1.147",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.604",
  "module-federation": "static-1.37",
  "opentelemetry-fe": "static-1.636",
  "quartz-auth": "static-1.1321",
  "quartz-test": "static-1.1321",
  "quartz-tracking": "static-1.1025",
  "trellis-components": "static-1.3087",
  "csstype": "static-1.50",
  "bend-plugin-chirp-manifest": "static-1.549",
  "HubStyle": "static-2.12264",
  "bender-build-tools": "static-1.3556",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.23830",
  "ContentUtils": "static-1.69456",
  "customer-data-objects-ui-components": "static-1.13502",
  "sassPrefix": "static-1.357",
  "diff-match-patch": "static-1.7",
  "batch-promise": "static-1.2015",
  "bend-plugin-pulse": "static-1.618",
  "event-emitter": "static-1.1431",
  "fast-json-patch": "static-1.74",
  "browser-eslint": "static-2.57",
  "magpie-lib": "static-1.5904",
  "magpie-types": "static-1.5364",
  "stylex-utils": "static-1.173",
  "trellis-theming": "static-1.1467",
  "avatar-components": "static-1.2955",
  "breeze-engine-core": "static-1.1415",
  "breeze-engine-lib": "static-1.2137",
  "breeze-onboarding-components": "static-1.1049",
  "customer-data-filters-ui": "static-1.41339",
  "customer-data-reference-ui-components": "static-1.13640",
  "data-integrations-breeze": "static-1.292",
  "embedded-academy-lib": "static-1.15990",
  "ExportDialog": "static-6.10841",
  "global-styles-ai-lib": "static-1.479",
  "highlight.js": "static-1.90",
  "marketplace-embed-ba": "static-1.892",
  "markdown-it": "static-1.6",
  "mermaid": "static-1.44",
  "reporting-action-components": "static-1.42382",
  "reporting-snowflake": "static-1.57940",
  "reporting-ui-components": "static-2.66593",
  "reporting-visualizations": "static-1.61398",
  "trial-components-library": "static-1.14364",
  "ui-addon-teams": "static-1.22005",
  "upgrade-components-lib": "static-1.708",
  "navigation-components": "static-1.19154",
  "nest": "static-1.705",
  "simple-logging-lib": "static-1.3520",
  "nudge-client-utils": "static-1.3408",
  "fail-safe": "static-1.416",
  "app-governance-lib": "static-1.2689",
  "developer-experience-shared-components": "static-1.11007",
  "purchase-motions-components": "static-1.6620",
  "transmute": "static-2.97",
  "usage-based-billing-components-lib": "static-1.10765",
  "usage-tracker-anonymous": "static-1.6209",
  "usage-tracker-public": "static-1.7603",
  "amplitude-session-replay-browser": "static-1.60",
  "inbound-db-meta-service-client": "static-1.3773",
  "persist-promise": "static-1.4172",
  "reference-resolvers": "static-1.8650",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "ui-extensibility-client-types": "static-1.4385",
  "hubspot-apollo-cache": "static-1.808",
  "universal-page-editor-lib": "static-1.3478",
  "final-form": "static-1.82",
  "redux-toolkit": "static-1.82",
  "simple-data-table": "static-1.3806",
  "merchandise-lib": "static-1.284",
  "onboarding-scopes": "static-1.6922",
  "ui-addon-draggable": "static-3.5218",
  "content-assistance-lib": "static-1.8412",
  "content-media-capture": "static-1.5775",
  "customer-data-ui-utilities": "static-1.10304",
  "emoji-mart": "static-3.7",
  "file-manager-components": "static-1.24822",
  "growth-payments-core": "static-1.26488",
  "knowledge-content-types": "static-1.8757",
  "PatternValidationJS": "static-1.3354",
  "payment-link-components": "static-1.24443",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.20540",
  "ui-addon-emoji-picker": "static-1.10333",
  "ui-business-units-lib": "static-1.9566",
  "video-components-external": "static-1.12417",
  "video-data-lib": "static-1.36075",
  "navigation-messaging": "static-1.8481",
  "collaboration-sidebar": "static-1.59038",
  "trellis-ext-dnd": "static-1.532",
  "crm-component-utils": "static-1.40168",
  "crm-properties-common-lib": "static-1.6360",
  "customer-data-properties": "static-1.53008",
  "external-options-client-types": "static-1.4438",
  "framework-data-schema-resolvers": "static-1.7361",
  "property-value-citations": "static-1.3622",
  "reference-resolvers-lite": "static-1.8576",
  "opentelemetry-web": "static-1.22",
  "hubspotter-http-shared-msw-handlers": "static-1.10887",
  "base-ui": "static-1.27",
  "react-day-picker": "static-1.14",
  "tanstack-virtual": "static-1.42",
  "cms-field-types": "static-1.5280",
  "content-icons-ui": "static-1.2452",
  "atom": "static-1.5543",
  "idb-keyval": "static-1.55",
  "reactive-lib": "static-1.1191",
  "trellis-migration-context": "static-1.47",
  "ably": "static-2.2",
  "breeze-engine-chat-components": "static-1.1115",
  "breeze-artifacts-sdk": "static-1.914",
  "getting-started-shared-tasks": "static-1.19549",
  "onboarding-journeys-lib": "static-1.1222",
  "conversations-skeleton-state": "static-1.7607",
  "crm-message-bus": "static-1.44084",
  "customer-data-filters-ui-msw-helpers": "static-1.23774",
  "events-data-lib": "static-1.714",
  "FormUrlGenerator": "static-2.5185",
  "framework-builder-read-service-client": "static-1.4332",
  "hs-resources": "static-1.664",
  "multi-account-reference-resolvers": "static-1.1475",
  "onboarding-tours": "static-1.17390",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.14757",
  "segments-client-types": "static-1.12120",
  "academy-common-lib": "static-1.15451",
  "dashboard-lib": "static-1.83282",
  "hubspot-prosemirror-plugins": "static-1.19257",
  "share-with-third-party-component-lib": "static-1.9179",
  "ui-asset-management-lib": "static-1.11570",
  "user-context": "static-1.5522",
  "reporting-plugins": "static-1.10974",
  "reporting-reports": "static-1.69000",
  "hubs-service-types": "static-1.1735",
  "purchase-motions-api": "static-1.6623",
  "salesImages": "static-1.726",
  "signup-constants": "static-1.19931",
  "nudge-custom-function-registry": "static-1.3165",
  "nudge-renderer-utils": "static-1.3484",
  "whisper-core-api": "static-1.7623",
  "bend-plugin-fail-safe": "static-1.367",
  "framework-listing-lib": "static-2.29782",
  "fuzzy": "static-1.8",
  "user-configuration-lib": "static-1.31741",
  "apps-service-types": "static-1.4096",
  "oauth-service-types": "static-1.4607",
  "signup-ui-url-generator": "static-2.8520",
  "onboarding-tours-client": "static-1.5605",
  "one-click-checkout": "static-1.735",
  "platform-infra-nav-components": "static-1.8001",
  "subscription-experience-data-types": "static-1.15429",
  "crm-record-cards-service-types": "static-1.3871",
  "location-customization-utils-lib": "static-1.10401",
  "redux-thunk": "static-2.84",
  "react-flip-move": "static-1.82",
  "ui-coaching-tips": "static-1.29577",
  "content-media-composition-data-lib": "static-1.13579",
  "fix-webm-duration": "static-1.34",
  "notification-sounds": "static-1.4896",
  "react-immutable-render-mixin": "static-1.9",
  "poll-commands": "static-1.3945",
  "seat-types-lib": "static-1.1035",
  "ui-addon-opt": "static-4.8869",
  "commerce-tours-lib": "static-1.6852",
  "growth-onboarding-reliability": "static-1.5551",
  "sales-checkout-service-client": "static-1.3992",
  "data-token-picker": "static-1.17122",
  "FileManagerLib": "static-1.40462",
  "content-media-compositions": "static-2.17586",
  "media-bridge-lib": "static-1.19629",
  "chatspot-widget-iframe": "static-1.23821",
  "collaboration-sidebar-common": "static-1.3835",
  "marketing-platform-lib": "static-1.7371",
  "dnd-kit": "static-1.20",
  "commerce-subscription-lib": "static-1.38037",
  "crm-actions": "static-1.6830",
  "crm-cards-sdk": "static-1.44996",
  "customer-data-properties-shared-msw-handlers": "static-1.10216",
  "customer-data-tracking": "static-1.7340",
  "calling-global-api": "static-1.66165",
  "calling-internal-common": "static-1.31796",
  "calling-lifecycle-internal": "static-1.67547",
  "calling-lifecycle-messages": "static-1.59840",
  "commerce-products-lib": "static-1.10889",
  "conditional-properties-service-client": "static-1.4111",
  "crm-index-visualization-core": "static-1.4748",
  "crm-links": "static-1.6777",
  "crm-pipelines-api-client-types": "static-1.4441",
  "formula-editor": "static-1.15002",
  "google-libphonenumber": "static-1.49",
  "inbounddb-objects-service-types": "static-1.4518",
  "meetings-icalendar-utils-lib": "static-1.1105",
  "multi-currency-client-types": "static-1.4005",
  "object-builder-ui-client": "static-1.50026",
  "pipeline-validation-client-types": "static-1.4278",
  "smart-data-capture-core": "static-1.461",
  "smart-property-lib": "static-1.8633",
  "tiered-pricing": "static-1.2238",
  "topics-actions-lib": "static-1.651",
  "trellis-ext-i18n": "static-1.1376",
  "ui-addon-form-validation": "static-1.11346",
  "zustand": "static-1.88",
  "fdsr-migration-layer": "static-1.480",
  "framework-data-schema-quick-fetch": "static-1.7266",
  "restore-request-side-panel-lib": "static-1.2020",
  "growth-data-modal": "static-1.6124",
  "growth-onboarding-confetti": "static-1.3530",
  "growth-onboarding-next-action-utils": "static-1.2969",
  "onboarding-tours-utils": "static-1.1457",
  "ui-shepherd-tracker": "static-1.8127",
  "crm-index-associations-lib": "static-1.6918",
  "academy-service-client": "static-1.4161",
  "croppie": "static-2.10",
  "FileManagerCore": "static-1.40321",
  "SafeStorage": "static-1.4864",
  "video-embed": "static-1.36909",
  "redux-actions": "static-3.74",
  "EmailSignatureEditor": "static-1.25234",
  "viral-links-lib": "static-1.7550",
  "nested-table": "static-1.700",
  "timezone-utils": "static-2.5700",
  "getting-started-shared-tasks-store": "static-1.18667",
  "campaign-roi-lib": "static-1.10801",
  "campaigns-utils-lib": "static-1.3713",
  "ui-addon-calendars": "static-2.5834",
  "customer-data-views-management": "static-1.26339",
  "framework-data-table": "static-2.12829",
  "nudge-custom-ui-functions": "static-1.1728",
  "switchboard-lib": "static-1.702",
  "access-check-ui-lib": "static-1.1871",
  "app-users-service-client": "static-1.6089",
  "app-users-service-types": "static-1.5497",
  "mini-checkout-client": "static-1.27830",
  "onboarding-utils": "static-1.5843",
  "permissions-shared-i18n-strings-fe": "static-1.2143",
  "ui-coaching-tips-shared-config": "static-1.29562",
  "checkout-sdk": "static-3.24673",
  "payment-method-components": "static-1.7311",
  "touchless-buying-components": "static-1.6541",
  "upgrade-catalog-service-types": "static-1.3893",
  "edison-service-client-types": "static-1.862",
  "growth-onboarding-feedback-components": "static-1.7052",
  "audio-components": "static-1.6559",
  "FileManagerImages": "static-1.37973",
  "video-components": "static-1.14419",
  "js-cookie": "static-1.18",
  "commerce-billing-lib": "static-1.20478",
  "commerce-shared-components-lib": "static-1.19552",
  "commerce-tools-ui-lib": "static-1.11310",
  "crm_data": "static-4.93189",
  "crm-activity-creator-data": "static-1.47700",
  "crm-fe-perf": "static-1.23366",
  "universal-record-utils-lib": "static-1.2347",
  "calling-error-reporting": "static-1.31803",
  "shared-worker-versioning": "static-1.11509",
  "calling-usage-tracker": "static-1.7006",
  "voice-sms-access-library": "static-1.2422",
  "commerce-permissions": "static-1.1255",
  "products-iframe-lib": "static-1.8896",
  "products-ui-components-shared-msw-handlers": "static-1.11271",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.10972",
  "sales-views-client-types": "static-1.4724",
  "bark-lib": "static-1.16999",
  "browser-prettier": "static-1.11",
  "data-agent-kit": "static-1.902",
  "data-agent-test-utils": "static-1.446",
  "data-agent-utils": "static-1.915",
  "policy-lib": "static-1.7279",
  "react-tinymce": "static-1.56257",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.11035",
  "tinymce-config": "static-2.55383",
  "tinymce-plugins": "static-1.58497",
  "onboarding-data-sync-lib": "static-1.2831",
  "growth-onboarding-next-action-components": "static-1.2997",
  "user-context-client": "static-1.4979",
  "cropperjs": "static-1.10",
  "html-to-image": "static-1.65",
  "urlinator": "static-1.4984",
  "outpost": "static-1.4598",
  "draft-convert": "static-2.83",
  "draft-extend": "static-3.87",
  "draft-js": "static-5.89",
  "draft-plugins": "static-2.22346",
  "sales-email-signature-service-client": "static-1.4317",
  "ts-utils-lib": "static-1.620",
  "copilot-messaging": "static-1.2382",
  "crm-export-dialog": "static-1.6746",
  "crm-index-ui-shimmer": "static-1.2959",
  "crm-view-components": "static-1.1479",
  "react-beautiful-dnd": "static-1.74",
  "customer-data-associations": "static-1.7807",
  "tasks-actions-lib": "static-1.420",
  "InboxConnectUtils": "static-4.15830",
  "emoji-regex": "static-1.7",
  "hub-http-rxjs": "static-1.877",
  "normalizr": "static-3.9",
  "ramda": "static-1.7",
  "billing-payments-client-types": "static-1.4457",
  "company-details-components": "static-1.6675",
  "react-performance-metrics-lib": "static-1.1023",
  "pricing-pages-ui-components": "static-1.16511",
  "quote-checkout-service-types": "static-1.3927",
  "social-insights-client-types": "static-1.22915",
  "utility-belt": "static-1.3005",
  "payments-enrollment-embed-lib": "static-1.24179",
  "stripe-embedded-components": "static-1.8233",
  "customer-data-rte": "static-1.33890",
  "cv-backend-services": "static-1.1607",
  "growth-onboarding-empty-states": "static-1.6521",
  "payments-post-enroll-local-storage-lib": "static-1.5573",
  "qrcode-generator": "static-1.80",
  "quotes-client-types": "static-1.39156",
  "crm_universal": "static-1.22715",
  "customer-data-email": "static-1.18628",
  "meetings-rte-lib": "static-1.532",
  "universal-associations-select": "static-1.11560",
  "crm-object-search-query-utilities": "static-1.10444",
  "calling-orchestration-schema": "static-1.37199",
  "react-reducer-toolkit": "static-1.16656",
  "enrichment-settings-lib": "static-1.220",
  "tinymce": "static-5.11",
  "tinymce-themes": "static-1.57353",
  "hub-http-contrib": "static-1.3499",
  "interframe": "static-3.5209",
  "tinymce-data": "static-1.41468",
  "ui-addon-sales-email": "static-1.5672",
  "layout-dnd-components": "static-1.13215",
  "layout-dnd-utils": "static-1.12190",
  "ui-brand-identity-lib": "static-1.16928",
  "meetings-connect-utils-lib": "static-1.8086",
  "company-details-service-types": "static-1.4413",
  "segments-query-core": "static-1.1901",
  "pricing-pages-api": "static-1.16376",
  "stripe-connect-js": "static-1.82",
  "draft-content-plugins": "static-1.29143",
  "sequences-lib": "static-1.8760",
  "ui-gdpr-components": "static-1.10655",
  "meetings-client-types": "static-1.4057",
  "meetings-core": "static-1.754",
  "NamespacedHubStyle": "static-2.9365",
  "ContentData": "static-1.69531",
  "layout-data-lib": "static-1.10515",
  "sequences-client-types-lib": "static-1.8617",
  "advanced-menus-core": "static-1.15806",
  "advanced-menus-lib": "static-1.12562",
  "ui-memberships-settings-lib": "static-1.35162",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.15805",
  "simple-menus-lib": "static-1.17322"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.13498",
  "apollo-dlb": "/apollo-dlb/static-3.98",
  "breeze-builder-lib": "/breeze-builder-lib/static-1.1123",
  "client-types": "/client-types/static-1.510",
  "data-fetching-client": "/data-fetching-client/static-1.10108",
  "foundations-components": "/foundations-components/static-1.8738",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.1763",
  "foundations-theming": "/foundations-theming/static-1.4957",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.93",
  "head-dlb": "/head-dlb/static-1.5007",
  "hs-test-utils": "/hs-test-utils/static-1.8506",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.10889",
  "hubspot-dlb": "/hubspot-dlb/static-2.1911",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.4383",
  "HubStyleTokens": "/HubStyleTokens/static-2.11957",
  "I18n": "/I18n/static-7.1706",
  "jasmine-runner": "/jasmine-runner/static-1.6920",
  "marketplace-discovery-studio-lib": "/marketplace-discovery-studio-lib/static-1.894",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.13561",
  "quartz": "/quartz/static-1.7646",
  "react-dlb": "/react-dlb/static-1.93",
  "react-rhumb": "/react-rhumb/static-1.17204",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.3321",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.11257",
  "reselect": "/reselect/static-3.16",
  "settings-ui-lib": "/settings-ui-lib/static-1.12997",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.187",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.7838",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.11616",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9997",
  "unified-auth": "/unified-auth/static-1.1236",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.1518",
  "usage-tracker": "/usage-tracker/static-1.7792",
  "usage-tracker-core": "/usage-tracker-core/static-1.7642",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.8518",
  "hub-http": "/hub-http/static-1.6677",
  "integrations-lib": "/integrations-lib/static-1.17416",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.21036",
  "marketplace-ui-install": "/marketplace-ui-install/static-1.1022",
  "property-management-iframe": "/property-management-iframe/static-1.14438",
  "quartz-config": "/quartz-config/static-1.1424",
  "quartz-core": "/quartz-core/static-1.6865",
  "quartz-routing": "/quartz-routing/static-1.1076",
  "quick-fetch": "/quick-fetch/static-1.4229",
  "react": "/react/static-7.202",
  "rpc-client-utils": "/rpc-client-utils/static-1.5139",
  "ts-schema": "/ts-schema/static-1.4391",
  "ui-universal-auth": "/ui-universal-auth/static-1.9722",
  "UIComponents": "/UIComponents/static-3.8903",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.94",
  "enviro": "/enviro/static-4.455",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5587",
  "PortalIdParser": "/PortalIdParser/static-2.404",
  "raven": "/raven/static-3.5925",
  "raven-hubspot": "/raven-hubspot/static-1.6232",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.88",
  "metrics-js": "/metrics-js/static-1.9990",
  "react-redux": "/react-redux/static-7.80",
  "redux": "/redux/static-4.81",
  "styled-components": "/styled-components/static-2.100",
  "moment": "/moment/static-3.75",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3923",
  "quartz-webpack": "/quartz-webpack/static-1.3870",
  "bend-plugin-quartz-routing": "/bend-plugin-quartz-routing/static-1.724",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.10006",
  "codemirror": "/codemirror/static-5.106",
  "foundations-assets": "/foundations-assets/static-1.5354",
  "pulse": "/pulse/static-1.1115",
  "react-codemirror": "/react-codemirror/static-1.11109",
  "ui-extensions-preview-lib": "/ui-extensions-preview-lib/static-1.944",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.5007",
  "floating-ui": "/floating-ui/static-1.67",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.2673",
  "framer-motion": "/framer-motion/static-1.83",
  "hs-story-utils": "/hs-story-utils/static-1.9892",
  "react-aria": "/react-aria/static-1.76",
  "react-create-root-preference": "/react-create-root-preference/static-1.101",
  "react-select-plus": "/react-select-plus/static-1.117",
  "react-utils": "/react-utils/static-2.5654",
  "react-virtualized": "/react-virtualized/static-2.111",
  "StyleGuideUI": "/StyleGuideUI/static-3.518",
  "tanstack-table": "/tanstack-table/static-1.65",
  "trellis-assets": "/trellis-assets/static-1.3068",
  "ui-fonts": "/ui-fonts/static-1.1219",
  "ui-images": "/ui-images/static-2.1276",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.3440",
  "foundations-theming-base": "/foundations-theming-base/static-1.3942",
  "stylex": "/stylex/static-1.46",
  "HeadJS": "/HeadJS/static-2.820",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.3617",
  "msw": "/msw/static-1.102",
  "msw-config": "/msw-config/static-1.27",
  "testing-library": "/testing-library/static-1.163",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.234",
  "moment-timezone": "/moment-timezone/static-5.95",
  "jasmine": "/jasmine/static-4.4778",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.9093",
  "ai-rendering-library": "/ai-rendering-library/static-1.11386",
  "chirp-fetch": "/chirp-fetch/static-1.2372",
  "connections-embed-lib": "/connections-embed-lib/static-1.1734",
  "copilot-toolkit": "/copilot-toolkit/static-1.12132",
  "feedback-loader": "/feedback-loader/static-1.30050",
  "laboratory-lib": "/laboratory-lib/static-3.7617",
  "marketplace-embed": "/marketplace-embed/static-1.23189",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.10931",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.20991",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.15206",
  "sanitize-text": "/sanitize-text/static-1.8627",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.6206",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.5478",
  "wootric-nps": "/wootric-nps/static-1.7295",
  "beacon-keepalive-queue": "/beacon-keepalive-queue/static-1.169",
  "quartz-head": "/quartz-head/static-1.1311",
  "web-vitals": "/web-vitals/static-1.19",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.5056",
  "immer": "/immer/static-1.105",
  "immerable": "/immerable/static-1.4611",
  "highcharts": "/highcharts/static-8.115",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2828",
  "reporting-data": "/reporting-data/static-1.69324",
  "cssUtils": "/cssUtils/static-1.1093",
  "flux-actions": "/flux-actions/static-1.380",
  "react-colorpicker": "/react-colorpicker/static-2.10678",
  "react-dnd-compat": "/react-dnd-compat/static-1.5080",
  "redux-observable": "/redux-observable/static-1.79",
  "ReduxMessenger": "/ReduxMessenger/static-2.10838",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7782",
  "icons": "/icons/static-2.702",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.19568",
  "storybook-react": "/storybook-react/static-1.44",
  "trellis-story-utils": "/trellis-story-utils/static-1.4968",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.6221",
  "quartz-i18n": "/quartz-i18n/static-1.1321",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "adobe-sign-auth-lib": "/adobe-sign-auth-lib/static-1.750",
  "ads-unified-auth-lib": "/ads-unified-auth-lib/static-1.1936",
  "ai-mcp-auth-lib": "/ai-mcp-auth-lib/static-1.10",
  "custom-vendor-connection-lib": "/custom-vendor-connection-lib/static-1.286",
  "google-sheets-integration-lib": "/google-sheets-integration-lib/static-1.1319",
  "microsoft-drive-auth-lib": "/microsoft-drive-auth-lib/static-1.479",
  "slack-ui-library": "/slack-ui-library/static-1.10869",
  "surveymonkey-integration-lib": "/surveymonkey-integration-lib/static-1.852",
  "fsm": "/fsm/static-1.4227",
  "customer-data-objects": "/customer-data-objects/static-1.8168",
  "property-translator": "/property-translator/static-1.5848",
  "hs-locale-management": "/hs-locale-management/static-1.398",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.8390",
  "hs-promise-utils": "/hs-promise-utils/static-1.6061",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.5349",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.14831",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.6086",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.8231",
  "sanitize": "/sanitize/static-1.4942",
  "superstore": "/superstore/static-1.5227",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.10746",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.8573",
  "hub-http-janus": "/hub-http-janus/static-1.905",
  "hubspotter-http": "/hubspotter-http/static-1.4973",
  "immutable-less": "/immutable-less/static-1.5122",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.18443",
  "nav-meta": "/nav-meta/static-1.30791",
  "react-window": "/react-window/static-1.13",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.18545",
  "ui-product-approvals-common": "/ui-product-approvals-common/static-1.1564",
  "ai-studio-lib": "/ai-studio-lib/static-1.12749",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.19265",
  "integrations-reconnect-lib": "/integrations-reconnect-lib/static-1.707",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.9543",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.8422",
  "ui-product-approvals": "/ui-product-approvals/static-1.29669",
  "ui-tool-access": "/ui-tool-access/static-1.10627",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.4150",
  "property-management-common": "/property-management-common/static-1.6726",
  "opentelemetry-fe-types": "/opentelemetry-fe-types/static-1.261",
  "dispatcher": "/dispatcher/static-1.147",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.604",
  "module-federation": "/module-federation/static-1.37",
  "opentelemetry-fe": "/opentelemetry-fe/static-1.636",
  "quartz-auth": "/quartz-auth/static-1.1321",
  "quartz-test": "/quartz-test/static-1.1321",
  "quartz-tracking": "/quartz-tracking/static-1.1025",
  "trellis-components": "/trellis-components/static-1.3087",
  "csstype": "/csstype/static-1.50",
  "bend-plugin-chirp-manifest": "/bend-plugin-chirp-manifest/static-1.549",
  "HubStyle": "/HubStyle/static-2.12264",
  "bender-build-tools": "/bender-build-tools/static-1.3556",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.23830",
  "ContentUtils": "/ContentUtils/static-1.69456",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.13502",
  "sassPrefix": "/sassPrefix/static-1.357",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "batch-promise": "/batch-promise/static-1.2015",
  "bend-plugin-pulse": "/bend-plugin-pulse/static-1.618",
  "event-emitter": "/event-emitter/static-1.1431",
  "fast-json-patch": "/fast-json-patch/static-1.74",
  "browser-eslint": "/browser-eslint/static-2.57",
  "magpie-lib": "/magpie-lib/static-1.5904",
  "magpie-types": "/magpie-types/static-1.5364",
  "stylex-utils": "/stylex-utils/static-1.173",
  "trellis-theming": "/trellis-theming/static-1.1467",
  "avatar-components": "/avatar-components/static-1.2955",
  "breeze-engine-core": "/breeze-engine-core/static-1.1415",
  "breeze-engine-lib": "/breeze-engine-lib/static-1.2137",
  "breeze-onboarding-components": "/breeze-onboarding-components/static-1.1049",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.41339",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.13640",
  "data-integrations-breeze": "/data-integrations-breeze/static-1.292",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.15990",
  "ExportDialog": "/ExportDialog/static-6.10841",
  "global-styles-ai-lib": "/global-styles-ai-lib/static-1.479",
  "highlight.js": "/highlight.js/static-1.90",
  "marketplace-embed-ba": "/marketplace-embed-ba/static-1.892",
  "markdown-it": "/markdown-it/static-1.6",
  "mermaid": "/mermaid/static-1.44",
  "reporting-action-components": "/reporting-action-components/static-1.42382",
  "reporting-snowflake": "/reporting-snowflake/static-1.57940",
  "reporting-ui-components": "/reporting-ui-components/static-2.66593",
  "reporting-visualizations": "/reporting-visualizations/static-1.61398",
  "trial-components-library": "/trial-components-library/static-1.14364",
  "ui-addon-teams": "/ui-addon-teams/static-1.22005",
  "upgrade-components-lib": "/upgrade-components-lib/static-1.708",
  "navigation-components": "/navigation-components/static-1.19154",
  "nest": "/nest/static-1.705",
  "simple-logging-lib": "/simple-logging-lib/static-1.3520",
  "nudge-client-utils": "/nudge-client-utils/static-1.3408",
  "fail-safe": "/fail-safe/static-1.416",
  "app-governance-lib": "/app-governance-lib/static-1.2689",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.11007",
  "purchase-motions-components": "/purchase-motions-components/static-1.6620",
  "transmute": "/transmute/static-2.97",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.10765",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.6209",
  "usage-tracker-public": "/usage-tracker-public/static-1.7603",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.60",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3773",
  "persist-promise": "/persist-promise/static-1.4172",
  "reference-resolvers": "/reference-resolvers/static-1.8650",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.4385",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.808",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.3478",
  "final-form": "/final-form/static-1.82",
  "redux-toolkit": "/redux-toolkit/static-1.82",
  "simple-data-table": "/simple-data-table/static-1.3806",
  "merchandise-lib": "/merchandise-lib/static-1.284",
  "onboarding-scopes": "/onboarding-scopes/static-1.6922",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.5218",
  "content-assistance-lib": "/content-assistance-lib/static-1.8412",
  "content-media-capture": "/content-media-capture/static-1.5775",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.10304",
  "emoji-mart": "/emoji-mart/static-3.7",
  "file-manager-components": "/file-manager-components/static-1.24822",
  "growth-payments-core": "/growth-payments-core/static-1.26488",
  "knowledge-content-types": "/knowledge-content-types/static-1.8757",
  "PatternValidationJS": "/PatternValidationJS/static-1.3354",
  "payment-link-components": "/payment-link-components/static-1.24443",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.20540",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.10333",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.9566",
  "video-components-external": "/video-components-external/static-1.12417",
  "video-data-lib": "/video-data-lib/static-1.36075",
  "navigation-messaging": "/navigation-messaging/static-1.8481",
  "collaboration-sidebar": "/collaboration-sidebar/static-1.59038",
  "trellis-ext-dnd": "/trellis-ext-dnd/static-1.532",
  "crm-component-utils": "/crm-component-utils/static-1.40168",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.6360",
  "customer-data-properties": "/customer-data-properties/static-1.53008",
  "external-options-client-types": "/external-options-client-types/static-1.4438",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.7361",
  "property-value-citations": "/property-value-citations/static-1.3622",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.8576",
  "opentelemetry-web": "/opentelemetry-web/static-1.22",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.10887",
  "base-ui": "/base-ui/static-1.27",
  "react-day-picker": "/react-day-picker/static-1.14",
  "tanstack-virtual": "/tanstack-virtual/static-1.42",
  "cms-field-types": "/cms-field-types/static-1.5280",
  "content-icons-ui": "/content-icons-ui/static-1.2452",
  "atom": "/atom/static-1.5543",
  "idb-keyval": "/idb-keyval/static-1.55",
  "reactive-lib": "/reactive-lib/static-1.1191",
  "trellis-migration-context": "/trellis-migration-context/static-1.47",
  "ably": "/ably/static-2.2",
  "breeze-engine-chat-components": "/breeze-engine-chat-components/static-1.1115",
  "breeze-artifacts-sdk": "/breeze-artifacts-sdk/static-1.914",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.19549",
  "onboarding-journeys-lib": "/onboarding-journeys-lib/static-1.1222",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7607",
  "crm-message-bus": "/crm-message-bus/static-1.44084",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.23774",
  "events-data-lib": "/events-data-lib/static-1.714",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.5185",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.4332",
  "hs-resources": "/hs-resources/static-1.664",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.1475",
  "onboarding-tours": "/onboarding-tours/static-1.17390",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.14757",
  "segments-client-types": "/segments-client-types/static-1.12120",
  "academy-common-lib": "/academy-common-lib/static-1.15451",
  "dashboard-lib": "/dashboard-lib/static-1.83282",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.19257",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.9179",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.11570",
  "user-context": "/user-context/static-1.5522",
  "reporting-plugins": "/reporting-plugins/static-1.10974",
  "reporting-reports": "/reporting-reports/static-1.69000",
  "hubs-service-types": "/hubs-service-types/static-1.1735",
  "purchase-motions-api": "/purchase-motions-api/static-1.6623",
  "salesImages": "/salesImages/static-1.726",
  "signup-constants": "/signup-constants/static-1.19931",
  "nudge-custom-function-registry": "/nudge-custom-function-registry/static-1.3165",
  "nudge-renderer-utils": "/nudge-renderer-utils/static-1.3484",
  "whisper-core-api": "/whisper-core-api/static-1.7623",
  "bend-plugin-fail-safe": "/bend-plugin-fail-safe/static-1.367",
  "framework-listing-lib": "/framework-listing-lib/static-2.29782",
  "fuzzy": "/fuzzy/static-1.8",
  "user-configuration-lib": "/user-configuration-lib/static-1.31741",
  "apps-service-types": "/apps-service-types/static-1.4096",
  "oauth-service-types": "/oauth-service-types/static-1.4607",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.8520",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.5605",
  "one-click-checkout": "/one-click-checkout/static-1.735",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.8001",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.15429",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3871",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.10401",
  "redux-thunk": "/redux-thunk/static-2.84",
  "react-flip-move": "/react-flip-move/static-1.82",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.29577",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.13579",
  "fix-webm-duration": "/fix-webm-duration/static-1.34",
  "notification-sounds": "/notification-sounds/static-1.4896",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "poll-commands": "/poll-commands/static-1.3945",
  "seat-types-lib": "/seat-types-lib/static-1.1035",
  "ui-addon-opt": "/ui-addon-opt/static-4.8869",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.6852",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.5551",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3992",
  "data-token-picker": "/data-token-picker/static-1.17122",
  "FileManagerLib": "/FileManagerLib/static-1.40462",
  "content-media-compositions": "/content-media-compositions/static-2.17586",
  "media-bridge-lib": "/media-bridge-lib/static-1.19629",
  "chatspot-widget-iframe": "/chatspot-widget-iframe/static-1.23821",
  "collaboration-sidebar-common": "/collaboration-sidebar-common/static-1.3835",
  "marketing-platform-lib": "/marketing-platform-lib/static-1.7371",
  "dnd-kit": "/dnd-kit/static-1.20",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.38037",
  "crm-actions": "/crm-actions/static-1.6830",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.44996",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.10216",
  "customer-data-tracking": "/customer-data-tracking/static-1.7340",
  "calling-global-api": "/calling-global-api/static-1.66165",
  "calling-internal-common": "/calling-internal-common/static-1.31796",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.67547",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.59840",
  "commerce-products-lib": "/commerce-products-lib/static-1.10889",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.4111",
  "crm-index-visualization-core": "/crm-index-visualization-core/static-1.4748",
  "crm-links": "/crm-links/static-1.6777",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.4441",
  "formula-editor": "/formula-editor/static-1.15002",
  "google-libphonenumber": "/google-libphonenumber/static-1.49",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4518",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.1105",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.4005",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.50026",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.4278",
  "smart-data-capture-core": "/smart-data-capture-core/static-1.461",
  "smart-property-lib": "/smart-property-lib/static-1.8633",
  "tiered-pricing": "/tiered-pricing/static-1.2238",
  "topics-actions-lib": "/topics-actions-lib/static-1.651",
  "trellis-ext-i18n": "/trellis-ext-i18n/static-1.1376",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.11346",
  "zustand": "/zustand/static-1.88",
  "fdsr-migration-layer": "/fdsr-migration-layer/static-1.480",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.7266",
  "restore-request-side-panel-lib": "/restore-request-side-panel-lib/static-1.2020",
  "growth-data-modal": "/growth-data-modal/static-1.6124",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.3530",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.2969",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.1457",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.8127",
  "crm-index-associations-lib": "/crm-index-associations-lib/static-1.6918",
  "academy-service-client": "/academy-service-client/static-1.4161",
  "croppie": "/croppie/static-2.10",
  "FileManagerCore": "/FileManagerCore/static-1.40321",
  "SafeStorage": "/SafeStorage/static-1.4864",
  "video-embed": "/video-embed/static-1.36909",
  "redux-actions": "/redux-actions/static-3.74",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.25234",
  "viral-links-lib": "/viral-links-lib/static-1.7550",
  "nested-table": "/nested-table/static-1.700",
  "timezone-utils": "/timezone-utils/static-2.5700",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.18667",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.10801",
  "campaigns-utils-lib": "/campaigns-utils-lib/static-1.3713",
  "ui-addon-calendars": "/ui-addon-calendars/static-2.5834",
  "customer-data-views-management": "/customer-data-views-management/static-1.26339",
  "framework-data-table": "/framework-data-table/static-2.12829",
  "nudge-custom-ui-functions": "/nudge-custom-ui-functions/static-1.1728",
  "switchboard-lib": "/switchboard-lib/static-1.702",
  "access-check-ui-lib": "/access-check-ui-lib/static-1.1871",
  "app-users-service-client": "/app-users-service-client/static-1.6089",
  "app-users-service-types": "/app-users-service-types/static-1.5497",
  "mini-checkout-client": "/mini-checkout-client/static-1.27830",
  "onboarding-utils": "/onboarding-utils/static-1.5843",
  "permissions-shared-i18n-strings-fe": "/permissions-shared-i18n-strings-fe/static-1.2143",
  "ui-coaching-tips-shared-config": "/ui-coaching-tips-shared-config/static-1.29562",
  "checkout-sdk": "/checkout-sdk/static-3.24673",
  "payment-method-components": "/payment-method-components/static-1.7311",
  "touchless-buying-components": "/touchless-buying-components/static-1.6541",
  "upgrade-catalog-service-types": "/upgrade-catalog-service-types/static-1.3893",
  "edison-service-client-types": "/edison-service-client-types/static-1.862",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.7052",
  "audio-components": "/audio-components/static-1.6559",
  "FileManagerImages": "/FileManagerImages/static-1.37973",
  "video-components": "/video-components/static-1.14419",
  "js-cookie": "/js-cookie/static-1.18",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.20478",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.19552",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.11310",
  "crm_data": "/crm_data/static-4.93189",
  "crm-activity-creator-data": "/crm-activity-creator-data/static-1.47700",
  "crm-fe-perf": "/crm-fe-perf/static-1.23366",
  "universal-record-utils-lib": "/universal-record-utils-lib/static-1.2347",
  "calling-error-reporting": "/calling-error-reporting/static-1.31803",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.11509",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.7006",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.2422",
  "commerce-permissions": "/commerce-permissions/static-1.1255",
  "products-iframe-lib": "/products-iframe-lib/static-1.8896",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.11271",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.10972",
  "sales-views-client-types": "/sales-views-client-types/static-1.4724",
  "bark-lib": "/bark-lib/static-1.16999",
  "browser-prettier": "/browser-prettier/static-1.11",
  "data-agent-kit": "/data-agent-kit/static-1.902",
  "data-agent-test-utils": "/data-agent-test-utils/static-1.446",
  "data-agent-utils": "/data-agent-utils/static-1.915",
  "policy-lib": "/policy-lib/static-1.7279",
  "react-tinymce": "/react-tinymce/static-1.56257",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.11035",
  "tinymce-config": "/tinymce-config/static-2.55383",
  "tinymce-plugins": "/tinymce-plugins/static-1.58497",
  "onboarding-data-sync-lib": "/onboarding-data-sync-lib/static-1.2831",
  "growth-onboarding-next-action-components": "/growth-onboarding-next-action-components/static-1.2997",
  "user-context-client": "/user-context-client/static-1.4979",
  "cropperjs": "/cropperjs/static-1.10",
  "html-to-image": "/html-to-image/static-1.65",
  "urlinator": "/urlinator/static-1.4984",
  "outpost": "/outpost/static-1.4598",
  "draft-convert": "/draft-convert/static-2.83",
  "draft-extend": "/draft-extend/static-3.87",
  "draft-js": "/draft-js/static-5.89",
  "draft-plugins": "/draft-plugins/static-2.22346",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.4317",
  "ts-utils-lib": "/ts-utils-lib/static-1.620",
  "copilot-messaging": "/copilot-messaging/static-1.2382",
  "crm-export-dialog": "/crm-export-dialog/static-1.6746",
  "crm-index-ui-shimmer": "/crm-index-ui-shimmer/static-1.2959",
  "crm-view-components": "/crm-view-components/static-1.1479",
  "react-beautiful-dnd": "/react-beautiful-dnd/static-1.74",
  "customer-data-associations": "/customer-data-associations/static-1.7807",
  "tasks-actions-lib": "/tasks-actions-lib/static-1.420",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.15830",
  "emoji-regex": "/emoji-regex/static-1.7",
  "hub-http-rxjs": "/hub-http-rxjs/static-1.877",
  "normalizr": "/normalizr/static-3.9",
  "ramda": "/ramda/static-1.7",
  "billing-payments-client-types": "/billing-payments-client-types/static-1.4457",
  "company-details-components": "/company-details-components/static-1.6675",
  "react-performance-metrics-lib": "/react-performance-metrics-lib/static-1.1023",
  "pricing-pages-ui-components": "/pricing-pages-ui-components/static-1.16511",
  "quote-checkout-service-types": "/quote-checkout-service-types/static-1.3927",
  "social-insights-client-types": "/social-insights-client-types/static-1.22915",
  "utility-belt": "/utility-belt/static-1.3005",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.24179",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.8233",
  "customer-data-rte": "/customer-data-rte/static-1.33890",
  "cv-backend-services": "/cv-backend-services/static-1.1607",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.6521",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.5573",
  "qrcode-generator": "/qrcode-generator/static-1.80",
  "quotes-client-types": "/quotes-client-types/static-1.39156",
  "crm_universal": "/crm_universal/static-1.22715",
  "customer-data-email": "/customer-data-email/static-1.18628",
  "meetings-rte-lib": "/meetings-rte-lib/static-1.532",
  "universal-associations-select": "/universal-associations-select/static-1.11560",
  "crm-object-search-query-utilities": "/crm-object-search-query-utilities/static-1.10444",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.37199",
  "react-reducer-toolkit": "/react-reducer-toolkit/static-1.16656",
  "enrichment-settings-lib": "/enrichment-settings-lib/static-1.220",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-themes": "/tinymce-themes/static-1.57353",
  "hub-http-contrib": "/hub-http-contrib/static-1.3499",
  "interframe": "/interframe/static-3.5209",
  "tinymce-data": "/tinymce-data/static-1.41468",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5672",
  "layout-dnd-components": "/layout-dnd-components/static-1.13215",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.12190",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.16928",
  "meetings-connect-utils-lib": "/meetings-connect-utils-lib/static-1.8086",
  "company-details-service-types": "/company-details-service-types/static-1.4413",
  "segments-query-core": "/segments-query-core/static-1.1901",
  "pricing-pages-api": "/pricing-pages-api/static-1.16376",
  "stripe-connect-js": "/stripe-connect-js/static-1.82",
  "draft-content-plugins": "/draft-content-plugins/static-1.29143",
  "sequences-lib": "/sequences-lib/static-1.8760",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10655",
  "meetings-client-types": "/meetings-client-types/static-1.4057",
  "meetings-core": "/meetings-core/static-1.754",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.9365",
  "ContentData": "/ContentData/static-1.69531",
  "layout-data-lib": "/layout-data-lib/static-1.10515",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.8617",
  "advanced-menus-core": "/advanced-menus-core/static-1.15806",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.12562",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.35162",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.15805",
  "simple-menus-lib": "/simple-menus-lib/static-1.17322"
}
};
